import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Chat as ChatIcon } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { useIntercom } from '../hooks/useIntercom';

interface IntercomChatButtonProps {
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'default';
  tooltip?: string;
}

const IntercomChatButton: React.FC<IntercomChatButtonProps> = ({
  size = 'medium',
  color = 'primary',
  tooltip = 'Open chat support',
}) => {
  const { show, isAvailable } = useIntercom();
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    const check = () => setAvailable(isAvailable());
    check();
    const id = window.setInterval(check, 1000);
    return () => window.clearInterval(id);
  }, [isAvailable]);

  const disabledTooltip = 'Enable analytics cookies to use live chat';

  return (
    <Tooltip title={available ? tooltip : disabledTooltip}>
      <Box component="span" sx={{ display: 'inline-block' }}>
        <IconButton
        onClick={show}
        size={size}
        color={color}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1000,
          backgroundColor: 'primary.main',
          color: 'white',
          '&:hover': {
            backgroundColor: 'primary.dark',
          },
          boxShadow: 3,
          opacity: available ? 1 : 0.6,
          cursor: available ? 'pointer' : 'not-allowed',
        }}
        disabled={!available}
        >
          <ChatIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default IntercomChatButton;
